<template>
  <NewShop />
</template>
<script>
import NewShop from "@/components/NewShop.vue";
export default {
  components: {
    NewShop
  }
}
</script>